var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(_vm.value)?_c('v-icon',_vm._g({},on),[_vm._v(_vm._s(_vm.iconTrue))]):_c('v-icon',_vm._g({},on),[_vm._v(_vm._s(_vm.iconFalse))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.value ? _vm.$t(_vm.labelTrue) : _vm.$t(_vm.labelFalse)))])])}
var staticRenderFns = []

export { render, staticRenderFns }